import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { reset_report_token } from "../../../lib/api/local";

// 20261023 대상 서버와 관리자 비밀번호를 재확인한 후 클라우드 정보만 초기화한다.
const WebReportTokenReset = ({ server, userSeq, userID, onClose, handleSelectedFunc }) => {
    const { t } = useTranslation();
    // 20261027 자동완성 시 React 변경 이벤트가 없어도 실제 입력값으로 재인증한다.
    const passwordInput = useRef(null);
    const [pending, setPending] = useState(false);
    const [error, setError] = useState("");
    const busy = useRef(false);
    // 20261023 요청 중 필터 변경으로 행이 사라져도 해제된 화면의 상태를 갱신하지 않는다.
    const mounted = useRef(true);
    useEffect(() => () => { mounted.current = false; }, []);
    const clearPassword = () => { if (passwordInput.current) passwordInput.current.value = ""; };
    const close = () => { if (!busy.current) { clearPassword(); setError(""); onClose(); } };
    const submit = async () => {
        if (busy.current) return;
        if (!passwordInput.current || !passwordInput.current.reportValidity()) return;
        // 20261027 관리자 번호 0은 허용하되 누락값이 숫자 0으로 변환되는 것은 막는다.
        if (userSeq === null || userSeq === undefined ||
            (typeof userSeq !== "number" && typeof userSeq !== "string") ||
            (typeof userSeq === "string" && userSeq.trim() === "") ||
            !Number.isInteger(Number(userSeq)) || Number(userSeq) < 0) {
            setError(t("보고_토큰_초기화_실패", { ns: "admin" }));
            return;
        }
        busy.current = true;
        setPending(true);
        setError("");
        const credentials = { localServerSeq: Number(server.localServerSeq), userSeq, password: passwordInput.current.value };
        clearPassword();
        try {
            const response = await reset_report_token(credentials);
            if (!response.data.isSuccessed) throw new Error("RESET_FAILED");
            if (mounted.current) onClose();
            handleSelectedFunc({ selectedFunc: "LOCAL_SERVER_TOKEN_RESET_DONE", data: { localServerSeq: credentials.localServerSeq } });
        } catch (ignored) {
            if (mounted.current) setError(t("보고_토큰_초기화_실패", { ns: "admin" }));
        } finally {
            credentials.password = "";
            busy.current = false;
            if (mounted.current) setPending(false);
        }
    };
    return (
        // 20261027 관리자 비밀번호 확인창을 화면 세로 가운데에 배치한다.
        <Modal isOpen centered toggle={close} backdrop="static" keyboard={!pending}>
            {/* 20261027 로그인 폼 제출 대신 버튼 클릭으로 재인증하고 비밀번호 입력란 자체를 검증한다. */}
            <div id="report-token-reset-dialog">
                <ModalHeader toggle={pending ? undefined : close}>{t("보고_토큰_초기화", { ns: "admin" })}</ModalHeader>
                <ModalBody>
                    <p>{server.localServerName} (#{server.localServerSeq})</p>
                    <p>{t("보고_토큰_초기화_설명", { ns: "admin" })}</p>
                    <label className="w-100">ID
                        <input type="text" name="username" className="form-control" autoComplete="section-token-reset username" value={userID || ""} readOnly />
                    </label>
                    <label className="w-100">{t("보고_토큰_관리자_비밀번호", { ns: "admin" })}
                        <input ref={passwordInput} type="password" name="password" className="form-control" autoComplete="section-token-reset current-password" maxLength={256} required disabled={pending} onKeyDown={event => {
                            if (event.key === "Enter" && !event.nativeEvent.isComposing) { event.preventDefault(); submit(); }
                        }} />
                    </label>
                    {error && <div role="alert" className="text-danger">{error}</div>}
                </ModalBody>
                <ModalFooter>
                    <button type="button" className="btn btn-secondary" disabled={pending} onClick={close}>{t("토큰_초기화_취소", { ns: "admin" })}</button>
                    <button type="button" className="btn btn-danger" disabled={pending} onClick={submit}>{t(pending ? "토큰_초기화_처리중" : "보고_토큰_초기화", { ns: "admin" })}</button>
                </ModalFooter>
            </div>
        </Modal>
    );
};
export default connect(state => ({ userSeq: state.user.userSeq, userID: state.user.userID }))(WebReportTokenReset);
